import * as React from 'react';
import * as style from './Layout.css';

export const Layout: React.FC<React.PropsWithChildren> = props => {
  const { children } = props;

  return <div className={style['container']}>{children}</div>;
};
